/* global $, data, query_string, pitchArsenalAverages */
import _ from 'underscore'
import Table from 'bam-node-savant-table/table'
import { appSettings } from 'bam-node-baseball-savant/leaderboard/appSettings'
import { toFixed } from '../utils'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'pitch_arsenals'

function getHighlightArray(pitchType, metricType) {
    const pitchTypeMetric = `${pitchType}_${metricType}`

    return pitchArsenalAverages[pitchTypeMetric]
        ? [
              pitchArsenalAverages[pitchTypeMetric] * 0.9,
              pitchArsenalAverages[pitchTypeMetric] * 1.0,
              pitchArsenalAverages[pitchTypeMetric] * 1.1,
          ]
        : [0, 30, 60]
}

$(document).ready(() => {
    $('#ddlHand').change(() => {
        $('#lblHand').html($('#ddlHand option:selected').text())
    })
    $('#ddlSeason').change(() => {
        const newSelYear = $('#ddlSeason option:selected').text()
        $('#lblSeason').html(newSelYear)

        // Slightly hacky way of removing "Avg. Spin" option for pre-Statcast years
        const selector = document.getElementById('ddlType')
        if (Number(newSelYear) < appSettings.pitchArsenals.spinCutoffYear) {
            if (selector.value === 'avg_spin') {
                selector.value = 'avg_speed'
                $('#lblType').html('Average Speed')
            }

            if (selector.options.length === 3) {
                selector.remove(2)
            }
        } else if (selector.options.length < 3) {
            selector.add(new Option('Average Spin', 'avg_spin'))
        }
    })

    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })

    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `Minimum Pitches: ${$('#ddlMin option:selected').text()}`
        )
    })

    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        let dataLoad = data
        if (query_string.team) {
            dataLoad = _.filter(
                dataLoad,
                (d) => d.name_abbrev === query_string.team
            )
        }
        const type = $('#ddlType').val()
        const precision = type === 'avg_spin' ? 0 : 1

        const headers = [
            {
                name: 'Pitcher',
                field: 'href',
                customSortField: 'name_display_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'pitcher',
            },
            {
                name: '4-Seamer',
                field: type === 'n_' ? `${type}ff` : `ff_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('ff', type),
            },
            {
                name: 'Sinker',
                field: type === 'n_' ? `${type}si` : `si_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('si', type),
            },
            {
                name: 'Cutter',
                field: type === 'n_' ? `${type}fc` : `fc_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('fc', type),
            },
            {
                name: 'Slider',
                field: type === 'n_' ? `${type}sl` : `sl_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('sl', type),
            },
            {
                name: 'Changeup',
                field: type === 'n_' ? `${type}ch` : `ch_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('ch', type),
            },

            {
                name: 'Curve',
                field: type === 'n_' ? `${type}cu` : `cu_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('cu', type),
            },
            {
                name: 'Splitter',
                field: type === 'n_' ? `${type}fs` : `fs_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('fs', type),
            },
            {
                name: 'Sweeper',
                field: type === 'n_' ? `${type}st` : `st_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('st', type),
            },
            {
                name: 'Slurve',
                field: type === 'n_' ? `${type}sv` : `sv_${type}`,
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(precision, ''),
                highlight: getHighlightArray('sv', type),
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }
        // eslint-disable-next-line no-new
        new Table({
            id: 'pitch_arsenals',
            repeatHeader: repeatHeaders,
            headers,
            data: dataLoad,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            showRank: true,
            highlightFalsy: false,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/pitch-arsenals?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&type=${$('#ddlType').val()}&hand=${$(
            '#ddlHand'
        ).val()}`
    })
    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/pitch-arsenals?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&type=${$('#ddlType').val()}&hand=${$(
            '#ddlHand'
        ).val()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', function clickHandler() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function eachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function eachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    function populateUrl() {
        const url = `/pitch-arsenals?year=${$('#ddlSeason').val()}&min=${$(
            '#ddlMin'
        ).val()}&type=${$('#ddlType').val()}&hand=${$(
            '#ddlHand'
        ).val()}&sort=${$('#sort').val()}&sortDir=${$('#sortDir').val()}`
        window.history.pushState('', '', url)
        return url
    }
})
